import { useCallback, useEffect, useState } from 'react';
import { projectsAPI } from '../../lib/api';
import { useProject } from '../../layout/ProjectLayout';
import { Avatar, btnGhost, fmtDateTime } from '../../components/ui';

const VERB_TEXT = {
  project_created: 'created the project',
  project_updated: 'updated the project',
  project_archived: 'archived the project',
  project_unarchived: 'unarchived the project',
  members_updated: 'updated the member list',
  group_created: 'added a task group',
  task_created: 'created a task',
  task_updated: 'updated a task',
  task_deleted: 'deleted a task',
  task_moved: 'moved a task',
  task_completed: 'completed a task',
  task_reopened: 'reopened a task',
  comment_added: 'commented',
};

function line(a) {
  const base = VERB_TEXT[a.verb] || a.verb;
  const title = a.meta?.title ? ` — “${a.meta.title}”` : '';
  const to = a.meta?.to ? ` to ${a.meta.to}` : '';
  const name = a.meta?.name && !a.meta?.title ? ` — “${a.meta.name}”` : '';
  return `${base}${to}${title}${name}`;
}

export default function ActivityScreen() {
  const { project } = useProject();
  const [items, setItems] = useState([]);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = useCallback(
    async (before = '') => {
      setBusy(true);
      try {
        const { data } = await projectsAPI.activity(project.id, before);
        setItems((prev) => (before ? [...prev, ...data.activities] : data.activities));
        if (data.activities.length < 50) setDone(true);
      } finally {
        setBusy(false);
      }
    },
    [project.id]
  );

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="mx-auto max-w-2xl">
      <ul className="space-y-3">
        {items.map((a) => (
          <li key={a.id} className="flex items-start gap-2.5">
            <Avatar name={a.actor_name} size={24} />
            <div className="min-w-0">
              <p className="text-sm">
                <span className="font-medium">{a.actor_name}</span>{' '}
                <span className="text-pm-muted">{line(a)}</span>
              </p>
              <p className="text-xs text-pm-faint">{fmtDateTime(a.created_at)}</p>
            </div>
          </li>
        ))}
        {items.length === 0 && !busy && <li className="text-sm text-pm-muted">No activity yet.</li>}
      </ul>
      {!done && items.length > 0 && (
        <button
          type="button"
          disabled={busy}
          onClick={() => load(items[items.length - 1].created_at)}
          className={`${btnGhost} mt-4 w-full`}
        >
          {busy ? 'Loading…' : 'Load more'}
        </button>
      )}
    </div>
  );
}
